
export default{
    data() {
        return {
            printer:{},
            lastAlignment:'left',
            lastIsBold:false,
            lastIsUnderline:false,
            lastSize:1,
            lastIndent:0
        };
    },
    mixins:[],
    computed:{
      
      
    },
    methods:{
        async openCashDrawer(){
            console.log('open drawer!!')
            try {
                const response = await fetch('http://localhost:8008/open-drawer', {
                method: 'POST'
                });

                const result = await response.json();

                if (!response.ok) {
                throw new Error(result.message || 'Failed to open drawer');
                }
            } catch (error) {
                console.error('Cash drawer error:', error);
            }
        },
        printReceiptDirect(receiptPrinterJob) {
            if (receiptPrinterJob.ip=='' || receiptPrinterJob.printLines.length==0){
                return //nothing to see here
            }

            //reset flags
            this.lastAlignment='left'
            this.lastIsBold=false
            this.lastIsUnderline=false
            this.lastSize=1
            this.lastIndent=0

            var mythis=this
            //console.log('print test ' + receiptPrinterJob.ip)

            //split the ip list into parts...so we can send to each
            var iplist = receiptPrinterJob.ip.split(";")
            for (let i = 0; i < iplist.length; i++){
                // Create a new ePOS device object
                const ePosDev = new epson.ePOSDevice();
                const printerIp = iplist[i]//receiptPrinterJob.ip  
                const port = '8008'; // Default ePOS port
                //console.log('print to ' + printerIp)


                // Connect to the printer
                ePosDev.connect(printerIp, port, (connectResult) => {
                    if (connectResult === 'OK' || connectResult === 'SSL_CONNECT_OK') {
                        //console.log('connected')
                        // Create a printer object
                        ePosDev.createDevice('local_printer', ePosDev.DEVICE_TYPE_PRINTER, {
                            'crypto': false,
                            'buffer': false
                        }, (deviceObj, deviceResult) => {
                            if (deviceResult === 'OK') {
                                this.printer = deviceObj;
                                this.printer.timeout = 60000; // Set a timeout
                                //console.log(this.printer)
                                //go through lines and setup
                                    receiptPrinterJob.printLines.forEach(myFunction2)
                                    function myFunction2(item, index, arr) {
                                        let li=arr[index]
                                        mythis.addLineToPrinterObject(mythis.printer,li)
                                    }  

                            
                                // Send the print data
                                this.printer.send();
                                console.log('send receipt to printer')
                            } else {
                                console.error('Failed to create printer device:', deviceResult);
                            }
                        });
                    } else {
                        console.error('Failed to connect to printer:', connectResult);
                    }
                });

            }   
        },
        addLineToPrinterObject(printer, li){
           // console.log('in the sub')
            //if its a space, just feed
            
             if(li.doFeed && li.doCut)   {
                printer.addFeed(2);
                printer.addCut(printer.CUT_FEED);
                return;
             }

                
            

            //alignment - only set if it has changed
            if(li.alignment!=this.lastAlignment){
                switch (li.alignment) {
                    case 'center':
                    printer.addTextAlign(printer.ALIGN_CENTER);
                    break;
                    case 'right':
                    printer.addTextAlign(printer.ALIGN_RIGHT);
                    break;
                    default:
                    printer.addTextAlign(printer.ALIGN_LEFT);
                    break;
                }
                this.lastAlignment=li.alignment
            }
            

            //styles
            if(this.lastIsBold!=li.isBold || this.lastIsUnderline!=li.isUnderline){
                if(li.isBold && li.isUnderline){
                    printer.addTextStyle(false, true, true);
                }else if (li.isBold){
                    printer.addTextStyle(false, false, true);
                }else if (li.isUnderline){
                    printer.addTextStyle(false, true, false);
                }else {
                    printer.addTextStyle(false, false, false);
                }
                this.lastIsBold=li.isBold
                this.lastIsUnderline=li.isUnderline
            }
            
            
            //size - only if it has changed
            if(this.lastSize!=li.textSize){
                if(li.textSize!=undefined){
                    printer.addTextSize(li.textSize,li.textSize);
                }else{
                    printer.addTextSize(1,1);
                }
                this.lastSize=li.textSize
            }
            
            
            //indent
            if(this.lastIndent!=li.indent){
                if(li.indent!=undefined){
                    printer.addTextPosition(li.indent);
                }else{
                    printer.addTextPosition(0);
                }
                this.lastIndent=li.indent
            }
            
            
            //text/space
            var txt = li.text
             if(li.isSpace!=undefined){
                if(li.isSpace){
                    txt = "             "
                }
            } 
            printer.addText(txt + '\n');   
               

            
            //image
            if(li.image!=undefined)   {
                document.getElementById('logo').src='./../' + li.image;
                var canvas = document.getElementById('canvas');
                var context = canvas.getContext('2d');
                context.drawImage(document.getElementById('logo'), 0, 0, 200, 70);
                printer.addImage(context, 0, 0, canvas.width, canvas.height, printer.COLOR_1);

            }

            // Feed and cut
            if(li.doFeed!=undefined){
                if(li.doFeed){printer.addFeed(2);}
            }
            if(li.doCut!=undefined){
                if(li.doCut){printer.addCut(printer.CUT_FEED);}
            }
            
        },
        
    }

}

